export default __webpack_public_path__ + "static/media/hair3.29a9e0c8.png";